import { render, staticRenderFns } from "./emoji_list.vue.js?vue&type=template&id=71d27b3d&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_list.vue?vue&type=template&id=71d27b3d&vue3"
import script from "./emoji_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_list.vue?vue&type=script&lang=js&vue3"
export * from "./emoji_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./emoji_list.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports